import React, {useContext, useMemo} from "react";
import {AppDataContext} from "../../../../App";
import _ from "lodash";
import {Button, IconButton} from "@mui/material";
import {OpenInNew as OpenInNewIcon} from "@mui/icons-material";
import PropTypes from "prop-types";
import UseApiManager from "../../../manager/api";

const UseMainListColumnDefs = ({onDetail}) => {

    const { state } = useContext(AppDataContext)
    const { GetOne } = UseApiManager()
    const columnDefs = useMemo(() => state.columnDefs, [state.columnDefs])

    return useMemo(() => {

        const columns = columnDefs.sort((v1, v2) => {
            if (!v1.ag_grid?.order && !v2.ag_grid?.order) return 0
            if(!v1.ag_grid?.order) return 1
            if(!v2.ag_grid?.order) return -1
            return v1.ag_grid.order - v2.ag_grid.order
        }).map(v => {
            console.log("columnDef col", v)
                let def = {
                    field: v.field,
                    headerName: v.name,
                    hide: v.hide ?? false,
                }
                let filter = _.isNil(v.ag_grid?.filter) ? true : v.ag_grid.filter
                if (filter === true) {
                    switch (v.data_type) {
                        case "string":
                            def.filter = "agTextColumnFilter"
                            break
                        case "int":
                        case "float":
                            def.filter = "agNumberColumnFilter"
                            break
                        case "bool":
                        case "boolean":
                            def.filter = "booleanColumnFilter"
                            break
                        default:
                            break
                    }
                } else if (filter === false) {
                    def.filter = false
                } else {
                    switch(filter) {
                        case "text":
                            def.filter = "agTextColumnFilter"
                            break
                        case "number":
                            def.filter = "agNumberColumnFilter"
                            break
                        case "date":
                            def.filter = "agDateColumnFilter"
                            break
                        case "distinct":
                            def.filter = "agSetColumnFilter"
                            def.filterParams = {
                                values: (params) =>
                                    GetOne(`tree/distinct/${params.colDef.field}`)
                                        .then(params.success)
                            }
                            break
                        case "distinctArray":
                            def.filter = "agSetColumnFilter"
                            def.filterParams = {
                                values: (params) =>
                                    GetOne(`tree/distinct_array/${params.colDef.field}`)
                                        .then(params.success)
                            }
                            break
                        case "exists":
                            def.filter = "agSetColumnFilter"
                            def.filterParams = {
                                values: ["有り", "無し"]
                            }
                            break
                        default:
                            def.filterParams = `${filter}ColumnFilterParams`
                            break
                    }
                }

                if (v.ag_grid?.renderer) {
                    def.cellRenderer = `${v.ag_grid.renderer}CellRenderer`
                }

                return def
            })

        console.log(columns)

        return [
            {
                cellRenderer: (params) => {
                    if (_.isNil(params.data)) return null
                    return (
                        <IconButton onClick={() => onDetail && onDetail(params.data)}>
                            <OpenInNewIcon style={{fontSize: "14px"}} />
                        </IconButton>
                    )
                }
            },
            ...columns,
        ]

    }, [columnDefs])
}

UseMainListColumnDefs.propTypes = {
    onDetail: PropTypes.func,
}

export default UseMainListColumnDefs
